import { AddressInput, Maybe } from '@buy-viasat/types/build/bv';

export type CustomerInfo = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  phoneNumberCountryCode: string;
  mobileNumber: string;
};

export type NavigationGeneratorAction = {
  billingAddress: Maybe<AddressInput> | undefined;
  shippingAddress: Maybe<AddressInput> | undefined;
  serviceAddress: AddressInput;
};

export type PhoneRegexes = {
  mobileRegex: RegExp;
  phoneRegex: RegExp;
};

export type CreateCustomerPartyAndRelnId = {
  partyId: string;
  relnId: string;
};

export enum MarketoRecordTypes {
  FIBER = 'Fiber',
}
